import type { AtomModel, Font, FormControlSetting, TypeSettings } from '@/app/editor/iframe/atom/Atom.model';
import throttle from '@/app/utils/throttle';
import STORE from '@/app/store/store';
import { GpChildProduct } from '@/app/editor/iframe/atom/module/GpChildProduct';

const formControlSettings: FormControlSetting[] = [
  {
    type: 'html:extraClass',
    name: 'extraClass',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
  {
    type: 'css:width',
    name: 'width',
    targetSelector: '.module-wrap .module',
    property: 'width',
    require: true,
  },
  {
    type: 'custom:align',
    name: 'align_lg',
    targetSelector: '.module',
    attrStoredSelector: 'gf_stock_counter',
    property: '',
  },
  {
    type: 'custom:align',
    name: 'align_md',
    targetSelector: '.module',
    attrStoredSelector: 'gf_stock_counter',
    property: '',
  },
  {
    type: 'custom:align',
    name: 'align_sm',
    targetSelector: '.module',
    attrStoredSelector: 'gf_stock_counter',
    property: '',
  },
  {
    type: 'custom:align',
    name: 'align_xs',
    targetSelector: '.module',
    attrStoredSelector: 'gf_stock_counter',
    property: '',
  },
  {
    type: 'html:attr',
    name: 'always_show_up',
    targetSelector: '.module',
    property: 'data-always-show-up',
    refreshType: 'all',
  },
  {
    type: 'html:attr',
    name: 'scarcity_thresold',
    targetSelector: '.module',
    property: 'data-scarcity-thresold',
    refreshType: 'all',
  },
  {
    type: 'html:attr',
    name: 'quantity_source',
    targetSelector: '.module',
    property: 'data-quantity-source',
    refreshType: 'all',
  },
  {
    type: 'html:attr',
    name: 'quantity_source',
    targetSelector: '.module',
    property: 'data-quantity-source',
    refreshType: 'all',
  },
  {
    type: 'html:attr',
    name: 'template',
    targetSelector: '.module',
    property: 'data-template',
    refreshType: 'all',
  },
  {
    type: 'html:attr',
    name: 'out_of_stock',
    targetSelector: '.module',
    property: 'data-out-of-stock',
    refreshType: 'all',
  },
  {
    type: 'html:attr',
    name: 'continue_out_of_stock',
    targetSelector: '.module',
    property: 'data-continue-out-of-stock',
    refreshType: 'all',
  },
  {
    type: 'html:attr',
    name: 'no_track_quantity',
    targetSelector: '.module',
    property: 'data-no-track-quantity',
    refreshType: 'all',
  },
  {
    type: 'html:attr',
    name: 'color',
    targetSelector: '.module',
    property: 'data-color',
    refreshType: 'all',
  },
  {
    type: 'html:attr',
    name: 'font_size',
    targetSelector: '.module',
    property: 'data-font-size',
    refreshType: 'all',
  },
  {
    type: 'html:attr',
    name: 'progress_bar_height',
    targetSelector: '.module',
    property: 'data-progress-bar-height',
    refreshType: 'all',
  },
  {
    type: 'html:attr',
    name: 'rounded_border',
    targetSelector: '.module',
    property: 'data-rounded-border',
    refreshType: 'all',
  },
  {
    type: 'html:attr',
    name: 'animation',
    targetSelector: '.module',
    property: 'data-animation',
    refreshType: 'all',
  },
  {
    type: 'html:attr',
    name: 'show_icon',
    targetSelector: '.module',
    property: 'data-show-icon',
    refreshType: 'all',
  },
  {
    type: 'html:attr',
    name: 'choose_icon',
    targetSelector: '.module',
    property: 'data-choose-icon',
    refreshType: 'all',
  },
];

/**
 * (P) View More Atom Module
 */
export class GpPStockCounter extends GpChildProduct {
  private throttleListenRefresh: Function;

  /** constructor
   * @param element DOM
   * @param options Seting
   */
  constructor(element: HTMLElement, options?: TypeSettings) {
    super(element, options);
    this.throttleListenRefresh = throttle(() => {
      this.render();
    }, 300);
  }

  /**
   * Return Atom data
   * @override Atom.getDataAtom
   * @returns object watch
   */
  getDataAtom(): AtomModel {
    const data: AtomModel = {
      type: this.getType(),
      id: this.getId(),
      nodeId: this.getIdNode(),
      name: '(P) Stock Counter',
      slug: 'p-stock-counter',
      groupName: 'Product',
      settings: this.getSettings(),
      data: this.getDataChilds(),
      html: this.getTemplate(),
      class: 'module-wrap',
      style: this.getStyle(),
      script: this.getScript(),
      libs: this.getLibs(),
      fonts: [] as Font[],
      version: 1,
      formControlSettings: formControlSettings,
    };
    return data;
  }

  /**
   * @override Atom.listenRefresh
   */
  listenRefresh() {
    STORE.events.listenOnlyOne(`refresh-${this.data.atom.id}`, this.throttleListenRefresh);
  }

  /**
   * @override Atom.getTargetClass
   */
  getTargetClass(): string {
    return '.module-wrap';
  }
}
